export default class MediaModel {
  constructor(item) {
    if (typeof item === "object") {
      this.id = item.id || "";
      this.name = item.name || "";
      this.type = item.type || "";
      this.status = item.status || "";
      this.boundEntityType = item.boundEntityType || "";
      this.contentType = item.contentType || null;
      this.contentLength = item.contentLength || null;
      this.cloudKey = item.cloudKey || null;
      this.url = item.url || null;
      this.createdAt = item.createdAt || null;
      this.createdByEmail = item.createdByEmail || "";
    } else {
      this.id = "";
      this.name = "";
      this.type = "";
      this.status = "";
      this.boundEntityType = "";
      this.contentType = null;
      this.contentLength = null;
      this.cloudKey = null;
      this.url = null;
      this.createdAt = null;
      this.createdByEmail = "";
    }
  }

  // MediaStatus enum
  static MediaStatus = {
    WaitingUpload: "WaitingUpload",
    Available: "Available",
  };

  // MediaType enum
  static MediaType = {
    Document: "Document",
    Image: "Image",
    Url: "Url",
  };
}
